import { FC } from "react";
import { Stack } from "@mui/material";
import { CommitmentUtilizationWidgetHighChart } from "../../../../../../../widgets/commitment-utlization/components/CommitmentUtilizationWidgetHighChart";
import { useAppSelector } from "@/store/hooks";
import { commitmentUtilizationWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/commitment-utilization/setup/commitmentUtilizationWidgetSetupDataSelector";
import { commitmentUtilizationSetupHasAggregationSelector } from "@/store/dashboards/selectors/setups/commitment-utilization/commitmentUtilizationSetupHasAggregationSelector";
import { commitmentUtilizationSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/commitment-utilization/commitmentUtilizationSetupPropertyByKeySelector";

export const CommitmentUtilizationWidgetSetupChartView: FC = () => {
  const hasAggregation = useAppSelector(
    commitmentUtilizationSetupHasAggregationSelector,
  );
  const visualization = useAppSelector(
    commitmentUtilizationSetupPropertyByKeySelector("visualization"),
  );
  const data = useAppSelector(commitmentUtilizationWidgetSetupDataSelector);
  const { groups } = data ?? {};

  if (!visualization) {
    return;
  }

  return (
    <Stack flex={1} p={2} justifyContent={hasAggregation ? "start" : "center"}>
      <CommitmentUtilizationWidgetHighChart
        data={groups}
        visualization={visualization}
        hasAggregations={hasAggregation}
      />
    </Stack>
  );
};
